export const CREATE_FOLDER = 'app/PlanSelection/CREATE_FOLDER'
export const FOLDER_CREATED = 'app/PlanSelection/FOLDER_CREATED'
export const CREATE_FOLDER_ERROR = 'app/PlanSelection/CREATE_FOLDER_ERROR'
export const CLEAR_CREATE_FOLDER = 'app/PlanSelection/CLEAR_CREATE_FOLDER'
export const SET_PROJECT_NAME = 'app/PlanSelection/SET_PROJECT_NAME'
export const CLEAR_PROJECT = 'app/PlanSelection/CLEAR_PROJECT'

export const CHECK_CAN_CREATE_PLAN =
  'app/ProjectSelection/CHECK_CAN_CREATE_PLAN'
export const CHECK_CAN_CREATE_PLAN_DONE =
  'app/ProjectSelection/CHECK_CAN_CREATE_PLAN_DONE'
export const CHECK_CAN_CREATE_PLAN_ERROR =
  'app/ProjectSelection/CHECK_CAN_CREATE_PLAN_ERROR'

// still imported directly by other reducers (e.g. Datasets, Search, Reports),
// kept even though PlanSelection's own reducer/saga no longer dispatch it
export const LOAD_PLANS = 'app/PlanSelection/LOAD_PLANS'

export const CLEAR_PLANS = 'app/PlanSelection/CLEAR_PLANS'
export const CLEAR_FOLDER_PLANS = 'app/PlanSelection/CLEAR_FOLDER_PLANS'
export const GET_ROOT_PLANS = 'app/PlanSelection/GET_ROOT_PLANS'
export const GET_ROOT_PLANS_DONE = 'app/PlanSelection/GET_ROOT_PLANS_DONE'
export const GET_ROOT_PLANS_ERROR = 'app/PlanSelection/GET_ROOT_PLANS_ERROR'
export const GET_ROOT_PLANS_WITH_FOLDERS =
  'app/PlanSelection/GET_ROOT_PLANS_WITH_FOLDERS'
export const GET_ROOT_PLANS_WITH_FOLDERS_DONE =
  'app/PlanSelection/GET_ROOT_PLANS_WITH_FOLDERS_DONE'
export const GET_ROOT_PLANS_WITH_FOLDERS_ERROR =
  'app/PlanSelection/GET_ROOT_PLANS_WITH_FOLDERS_ERROR'
export const GET_FOLDER_PLANS = 'app/PlanSelection/GET_FOLDER_PLANS'
export const GET_FOLDER_PLANS_DONE = 'app/PlanSelection/GET_FOLDER_PLANS_DONE'
export const GET_FOLDER_PLANS_ERROR = 'app/PlanSelection/GET_FOLDER_PLANS_ERROR'

export const VIEW_TYPES = {
  list: 'list',
  tiles: 'tiles'
}

export const ERROR_TYPES = {
  NEWER_CALL_CANCELED_PREVIOUS: 'NEWER_CALL_CANCELED_PREVIOUS'
}

export const renamePlanOptions = {
  FOLDER: 'folder',
  PLAN: 'plan'
}

export const planMenuApiErrorCodeOptions = {
  NO_PERMISSION_TO_CREATE_PLAN_OR_FOLDER: 403,
  PLAN_NAME_IS_NOT_AVAILABLE: 409,
  FOLDER_NAME_IS_NOT_AVAILABLE: 409,
  FOLDER_NO_LOGER_EXISTS: 400
}

export const planMenuItemTypeOptions = {
  PLAN: 'Plan',
  FOLDER: 'Folder'
}
